import SwipeableViews from 'react-swipeable-views';
import {
  virtualize,
} from 'react-swipeable-views-utils';

export const VirtualizedSwipeableViews = virtualize(SwipeableViews);
